import Base from './base'

export default class BBCLog extends Base {
  list(data: object) {
    return this.apiClient.get('bbc-log', data)
  }
}
